import type * as Style from '../../index.js'
import { RuleId, FixElementRuleIds, ValidatedArray } from '../../values/index.js'

export const Props = (props: any = {}) => ({
  fillIds: ValidatedArray(RuleId, props.fillIds),
  decorationIds: ValidatedArray(RuleId, props.decorationIds),
  layoutIds: ValidatedArray(RuleId, props.layoutIds),
  gridIds: ValidatedArray(RuleId, props.gridIds),
  spacingIds: ValidatedArray(RuleId, props.spacingIds),
  paletteIds: ValidatedArray(RuleId, props.paletteIds)
})

export type Props = ReturnType<typeof Props>
export const fix = (props: Props, styles: Style.Rule[]): Props => ({
  decorationIds: FixElementRuleIds('decoration', props.decorationIds, styles),
  fillIds: FixElementRuleIds('fill', props.fillIds, styles),
  spacingIds: FixElementRuleIds('spacing', props.spacingIds, styles),
  gridIds: FixElementRuleIds('grid', props.gridIds, styles),
  layoutIds: FixElementRuleIds('layout', props.layoutIds, styles),
  paletteIds: FixElementRuleIds('palette', props.paletteIds, styles)
})

export const validate = () => true
export const label = 'Blocks'
export const type = 'block'
export const category = 'element'
export const aspects = ['fill', 'decoration', 'spacing'] as const
